import { WorkCom } from '@wizeoo/akm-message-lib';
import { Model } from '../../model/model';
import { cloneDeep } from 'lodash';
import { WorkComVO } from '../../vo/workflow/workcom.vo';
import { WizConstants } from '../../model/constants';
import { FIELD_KIND } from '../../model/enums';
import { WizDateUtils } from '@wizeoo/akm-core-lib';

export interface WorkComReply {
  idx: number,
  content?: string,
  date?: number,
  who?: string,
}

export interface WorkcomParameters {
  from?: string,
  to?: string[],
  state?: string,
  imgBlob?: string,
  media?: any, //MediaReference,
  startDate?: number,
  endDate?: number,
  replies?: WorkComReply[],
  object?: string,
  comment?: string
}

/**
 * gestion des workflows
 */
export class WorkflowEngine {

  protected _model: Model = null;
  constructor(model: Model) {
    this._model = model;
  }
 

  public reset(): void {
    this._model.workcomList = null;
    this._model.workcomMap = null;
  }

  public getWorkcomCollection(): WorkComVO[] {
      return this._model.workcomList;
  }
  public setWorkcomCollection(value: WorkComVO[]) {
      this._model.workcomList = value;
  }


  public getWorkcomMap(): Map<string, WorkComVO> {
      return this._model.workcomMap;
  }
  public setWorkcomMap(value: Map<string, WorkComVO>) {
    // TODO TODO alimenter la map par parents...  
    this._model.workcomMap = value;
  }


  /**
   * sur changement des workcom, alimentation du modèle
   * @param wcs: WorkCom[]
   */
  public buildMap(wcs: WorkCom[]): void {
    const flatList: WorkComVO[] = wcs.map((wc) => new WorkComVO(this._model, wc));
    this._model.workcomList = flatList;

    this._model.workcomMap = new Map(flatList.map(item => [item.naturalUID, item]));
  }

  /**
   * Clone d'un workcom pour édition
   * @param item le workcom à cloner
   * @return workcomVO,  Un clone
   */
  public clone(item: WorkComVO): WorkComVO {
    const clone = new WorkComVO(this._model, cloneDeep(item.source));
    return clone;
  }


  /**
   * Récupération d'un workcom par son naturalID
   * @param naturalID
   */
  public getWorkCom(naturalID: string): WorkComVO {
    let wc: WorkComVO = this._model.workcomMap?.get(naturalID);
    return wc;
  }


  /**
   * Récupération des WorkComs par le couple visionCode / parentKey
   * @param visionCode la vision de rattachement de ce WorkCom
   * @param parentKey Le code du style
   */
  public getWorkComs(visionCode: string, parentKey: string): WorkComVO[] {
    
    return this._model.workcomList;
  }

  /**
   * suppression de l'instance d'un WorkComVO
   * @param naturalID
   */
  public removeWorkCom(naturalID: string): void {
    const toDie: WorkComVO = this.getWorkCom(naturalID);
    this._model.workcomList.splice(this._model.workcomList.indexOf(toDie), 1);
    this._model.workcomMap.delete(naturalID);
    // suppression de la map par vision / parentKey
    // let byKeyArr: WorkComVO[] = this.model.workcomByParentMap.get(toDie.vision).get(toDie.parentKey);
    // byKeyArr.splice(byKeyArr.indexOf(toDie), 1);
  }

  /**
   * ajout de l'instance d'un WorkCom
   * @param vo WorkCom
   */
  public addWorkCom(wc:WorkComVO): void {
    this._model.workcomList.push(wc);
    this._model.workcomMap.set(wc.naturalUID, wc);  
  }


  /**
   * mapping des champs d'un workcom
   * @param wc 
   * @returns 
   */
  public mapFields(wc: WorkComVO): Map<string, string> {
    let map: Map<string, string> = new Map();
        map.set("object", wc.obj);
        map.set("comment", wc.comment);
        map.set("from", wc.params?.from);
        map.set("state", wc.params?.state);
        map.set("to", wc.params?.to?.join(WizConstants.STYLE_ELEMENT_SEPARATOR));
        let startDate: string = null;
        if(wc.params?.startDate) {
                let format = this._model.formatEngine.getDefaultFormat(FIELD_KIND.DATE);
                startDate =  WizDateUtils.dateToString(WizDateUtils.stringToTime(wc.params.startDate.toString()), format.dateExp);
              }
        map.set("startDate", startDate);
        let endDate: string = null;
        if(wc.params?.endDate) {
                let format = this._model.formatEngine.getDefaultFormat(FIELD_KIND.DATE);
                endDate =  WizDateUtils.dateToString(WizDateUtils.stringToTime(wc.params.endDate.toString()), format.dateExp);
              }
        map.set("endDate", endDate);
    return map;
   }

  /**
   * accesseur sur un champ du workcom
   * @param naturalID 
   * @param field 
   * @returns 
   */
  public getValue(naturalID: string, field: string): string {
    let result: string = null;
    const wc: WorkComVO = this.getWorkCom(naturalID);
    if(!wc) { 
      return null;
    }

    let map: Map<string, string> = this.mapFields(wc);
    result = map.get(field) || null;

    return result;
  }


}


